<template>
    <component :is="display" v-bind="props" />
    <Meta
        title="Commercial Door Hardware & Security Manufacturers"
        description="Commercial Doors And Hardware distributor SECLOCK offer a variety of manufacturers for all your door hardware needs. Call 800.847.5625 for further inquiries."
        :jsonLdMainEntity="jsonLdMainEntityManufacturers(manufacturers)"
        :jsonLdBreadcrumbs="crumbs"
    />
</template>

<script setup>
import { useJsonLd, useUser } from "@/Composables";
import { Meta } from "@/Components";
import MarketingIndex from "../../../Themes/Marketing/Pages/Catalog/Manufacturers/Index.vue";
import SourcingIndex from "../../../Themes/Sourcing/Pages/Catalog/Manufacturers/Index.vue";
import {computed, markRaw} from "vue";

const { settings } = useUser();
const props = defineProps(["crumbs", "manufacturers", "tags"]);
const { jsonLdMainEntityManufacturers } = useJsonLd();

const display = computed(() =>
    settings.value.is_sourcing_mode ? markRaw(SourcingIndex) : markRaw(MarketingIndex)
);


</script>
